import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";

const customIcon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export const MiniMap = () => {
  const [rikshaws, setRikshaws] = useState([]);
  useEffect(() => {
    api.get("/rikshaws").then((r) => setRikshaws(r.data.rikshaws || []));
  }, []);

  return (
    <section
      className="py-20 md:py-28 bg-jow-cream"
      data-testid="home-mini-map"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 items-stretch">
        <div className="lg:col-span-4 flex flex-col justify-center">
          <span className="label-overline text-jow-gold">Live Fleet</span>
          <h2 className="font-display text-4xl md:text-5xl mt-2 text-jow-navy">
            Find a rikshaw near you.
          </h2>
          <p className="mt-4 text-jow-navy/65 max-w-md">
            Six beautifully decorated e-rikshaws across India, ready to bring our
            atelier to your doorstep. Tap a marker to meet the driver.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/find-us"
              data-testid="mini-map-cta-full"
              className="btn-primary-jow"
            >
              Open full locator <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="mt-10 grid grid-cols-2 gap-3 text-xs">
            {rikshaws.slice(0, 6).map((r) => (
              <div
                key={r.id}
                className="border border-jow-navy/10 bg-white px-3 py-2"
              >
                <p className="font-display text-base text-jow-navy">{r.city}</p>
                <p className="text-jow-navy/55 font-mono">{r.code}</p>
              </div>
            ))}
          </div>
        </div>

        <div
          className="lg:col-span-8 border border-jow-gold/40 bg-white"
          style={{ height: "480px" }}
          data-testid="mini-map-container"
        >
          <MapContainer
            center={[22.9734, 78.6569]}
            zoom={4}
            scrollWheelZoom={false}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {rikshaws.map((r) => (
              <Marker key={r.id} position={[r.lat, r.lng]} icon={customIcon}>
                <Popup>
                  <p style={{ fontFamily: '"Playfair Display", serif', fontSize: "1rem", color: "#0A1F44" }}>
                    {r.code}
                  </p>
                  <p style={{ fontSize: "0.78rem", color: "#0A1F44" }}>
                    {r.city} · {r.driver_name}
                  </p>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </section>
  );
};
